export const LICENSE_CONTACT_SALES_URL = 'https://monospace.io/demo';
